var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "home-header" }, [
    _c("div", { staticClass: "home-header-inner" }, [
      _c("img", {
        staticClass: "ebbly-logo",
        attrs: { src: require("../../../assets/images/logo.png") },
        on: { click: _vm.jump }
      }),
      _vm._v(" "),
      _c("ul", { staticClass: "header-menu" }, [
        _c(
          "li",
          { staticClass: "menu-item" },
          [
            _c(
              "el-select",
              {
                attrs: {
                  "value-key": "abbreviation",
                  disabled: _vm.payDisable
                },
                on: { change: _vm.changeCurrency },
                model: {
                  value: _vm.currency,
                  callback: function($$v) {
                    _vm.currency = $$v
                  },
                  expression: "currency"
                }
              },
              _vm._l(_vm.list, function(item) {
                return _c(
                  "el-option",
                  {
                    key: item.abbreviation,
                    attrs: { label: item.abbreviation, value: item }
                  },
                  [
                    _c("span", { staticStyle: { float: "left" } }, [
                      _c("img", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy",
                            value: item.image_url,
                            expression: "item.image_url"
                          }
                        ],
                        staticClass: "currency-flag"
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(item.abbreviation) +
                          "\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "currency-zone",
                        attrs: { title: item.country_name }
                      },
                      [_vm._v(_vm._s(item.country_name))]
                    )
                  ]
                )
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "menu-item lang-select" },
          [
            _c(
              "el-select",
              {
                on: { change: _vm.selectLang },
                model: {
                  value: _vm.lang,
                  callback: function($$v) {
                    _vm.lang = $$v
                  },
                  expression: "lang"
                }
              },
              _vm._l(_vm.langList, function(item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.text, value: item.lang }
                })
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "menu-item" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.ebbly.com/download.html#/",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v(_vm._s(_vm.$t("download_app")))]
          )
        ]),
        _vm._v(" "),
        !_vm.token
          ? _c(
              "li",
              { staticClass: "menu-item user-imp", on: { click: _vm.signin } },
              [
                _vm._v(
                  _vm._s(_vm.$t("signin")) + " / " + _vm._s(_vm.$t("signup"))
                )
              ]
            )
          : _c(
              "li",
              { staticClass: "menu-item user-imp" },
              [
                _c(
                  "el-dropdown",
                  { on: { command: _vm.selectUserMenu } },
                  [
                    _c("span", { staticClass: "user-dropdown" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy:background-image",
                            value: {
                              src:
                                _vm.avatar ||
                                require("../../../assets/avatar/default_avartar_boy@2x.png"),
                              error: require("../../../assets/avatar/default_avartar_boy@2x.png")
                            },
                            expression:
                              "{\n                            src: avatar || require('../../../assets/avatar/default_avartar_boy@2x.png'),\n                            error: require('../../../assets/avatar/default_avartar_boy@2x.png')\n                        }",
                            arg: "background-image"
                          }
                        ],
                        staticClass: "user-avatar"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "line-text" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.userMenu, function(item, index) {
                        return _c(
                          "el-dropdown-item",
                          { key: index, attrs: { command: item.link } },
                          [_vm._v(_vm._s(_vm.$t(item.text)))]
                        )
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17e6362a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e6362a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/Header.vue
// module id = null
// module chunks = 